export default __webpack_public_path__ + "static/media/page-not-found.bb90d073.svg";